// Import all services
import CoreServices from './services/module';


const services: any[] = [
  ...CoreServices.services
];



export default { services };